import { useLabels, useMapCore, useMapStore } from "../hooks";
import { Button } from "../primitives/Button";

export type ZoomControlProps = { className?: string };

export function ZoomControl({ className }: ZoomControlProps) {
  const core = useMapCore();
  const labels = useLabels();
  const zoom = useMapStore(a => a.view.zoom);
  const { minZoom, maxZoom } = core.options.view;

  return (
    <div className={["fxmap-zoom", "fxmap-stack", className ?? ""].filter(Boolean).join(" ")} data-fxmap="zoom" role="group" aria-label={labels.zoomIn}>
      <Button kind="icon" size="lg" icon="plus" label={labels.zoomIn} action="zoom-in" disabled={zoom >= maxZoom} onClick={() => core.view.zoomIn()} />
      <Button kind="icon" size="lg" icon="minus" label={labels.zoomOut} action="zoom-out" disabled={zoom <= minZoom} onClick={() => core.view.zoomOut()} />
      <span className="fxmap-zoom-level fxmap-mono" data-fxmap="zoom-level" title={labels.zoomLevel} aria-label={labels.zoomLevel}>
        {Math.round(zoom)}
      </span>
    </div>
  );
}
